import React from 'react';

const Close = () => (
  <svg width="10.604" height="10.604" viewBox="0 0 10.604 10.604">
    <path id="Icon_ionic-md-close-circle" data-name="Icon ionic-md-close-circle" d="M8.677,3.375a5.3,5.3,0,1,0,5.3,5.3A5.284,5.284,0,0,0,8.677,3.375Zm2.651,7.211-.742.742L8.677,9.419,6.768,11.328l-.742-.742L7.935,8.677,6.026,6.768l.742-.742L8.677,7.935l1.909-1.909.742.742L9.42,8.677Z" transform="translate(-3.375 -3.375)" fill="#231f20"/>
  </svg>);

export default Close;